import React from 'react';
import { Alert, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useInterventionCreation } from '../../context/interventionCreationContext';

/**
 * Bilan du dernier enregistrement de type d'intervention, affiché au-dessus de la table
 * comme les autres bilans de l'écran.
 *
 * Le champ enregistre dès sa sélection, sans attendre « Qualifier » : sans ce bandeau,
 * la mention sous le champ annonce le comportement sans jamais confirmer qu'il a eu lieu.
 */
export default function InterventionTypeReportBanner() {
  const { t } = useTranslation();
  const { state, dispatch } = useInterventionCreation();

  const report = state.lastInterventionTypeReport;

  if (report === null) {
    return null;
  }

  return (
    <Alert
      severity="success"
      closeText={t('close')}
      onClose={() => dispatch({ type: 'dismissInterventionTypeReport' })}
    >
      <Typography variant="body2">
        {t('interventionCreation.qualification.interventionTypeReport', {
          count: report.savedCount
        })}
      </Typography>
    </Alert>
  );
}
